<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row g-2">
      <div class="col-12 col-md-6">
        <label class="form-label">
          {{ trans("examination.center") }}
        </label>
        <input
          v-model="internalValue.name"
          type="text"
          class="form-control"
          :placeholder="trans('forms.searchForCenterPlaceholder')"
        />
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label">{{ trans("forms.hsaId") }}</label>
        <input
          v-model="internalValue.hsa_id"
          type="text"
          class="form-control"
          :placeholder="trans('forms.hsaId')"
        />
      </div>
    </div>

    <div class="row g-2 mt-1">
      <div class="col-12 col-md-6">
        <label class="form-label">
          {{ trans("admin.draftExaminations.product") }}
        </label>
        <generic-admin-filter
          v-model="internalValue.product_id"
          :placeholder="trans('admin.draftExaminations.product')"
          :base-url="filtersBaseUrl"
          endpoint="products"
          label-field="display_name"
          value-field="id"
        />
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label">{{ trans("admin.filters.feature") }}</label>
        <generic-admin-filter
          v-model="internalValue.feature_id"
          :placeholder="trans('admin.filters.feature')"
          :base-url="filtersBaseUrl"
          endpoint="features"
          label-field="name"
          value-field="id"
        />
      </div>
    </div>

    <div v-if="platformAttributeFilters.length > 0" class="row g-2 mt-1">
      <div
        v-for="filter in platformAttributeFilters"
        :key="filter.name"
        class="col-12 col-md-6"
      >
        <label class="form-label">{{ trans(filter.name) }}</label>
        <input
          v-model="internalValue.platformAttributes[filter.name]"
          type="text"
          class="form-control"
          :placeholder="trans(filter.name)"
        />
      </div>
    </div>

    <button type="submit" style="display: none" />

    <div class="row g-2 mt-1">
      <div class="col-12 col-md-6">
        <label class="form-label">{{ trans("forms.createdFrom") }}</label>
        <custom-datepicker
          :date="internalValue.created_from"
          :placeholder="trans('forms.createdFrom')"
          @on-date-change="internalValue.created_from = $event || null"
        />
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label">{{ trans("forms.createdTo") }}</label>
        <custom-datepicker
          :date="internalValue.created_to"
          :placeholder="trans('forms.createdTo')"
          @on-date-change="internalValue.created_to = $event || null"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">
          <i class="far fa-search" />
          {{ trans("general.search") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import GenericAdminFilter from "../Filters/GenericAdminFilter.vue";
import CustomDatepicker from "../../Utils/Datepicker.vue";

export default {
  name: "CentersFilterForm",
  components: { GenericAdminFilter, CustomDatepicker },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    filtersBaseUrl: {
      type: String,
      default: "/api/internal/admin/filters",
    },
    platformAttributeFilters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue", "search"],
  data() {
    const v = this.modelValue || {};
    return {
      internalValue: {
        ...v,
        platformAttributes: { ...(v.platformAttributes || {}) },
      },
    };
  },
  watch: {
    modelValue(v) {
      const safeV = v || {};
      this.internalValue = {
        ...safeV,
        platformAttributes: { ...(safeV.platformAttributes || {}) },
      };
    },
  },
  methods: {
    submit() {
      this.$emit("update:modelValue", { ...this.internalValue });
      this.$emit("search");
    },
  },
};
</script>
